import Vue from 'vue';
import {
    throttle
} from 'lodash-es';


Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                document.querySelector("body").removeEventListener('scroll', f)
            }
        }
        document.querySelector("body").addEventListener('scroll', throttle(f, 200))
    }
})

Vue.mixin({
    methods: {
        handleScroll: function (evt, el) {
            if (this.isVisible(el)) {
                if (el.dataset.scrollClass) {
                    const classes = el.dataset.scrollClass.split(" ");
                    classes.forEach(className => {
                        el.classList.add(className)
                    });
                }
            } else {
                if (el.dataset.scrollClass && !el.dataset.scrollOnce) {
                    const classes = el.dataset.scrollClass.split(" ");
                    classes.forEach(className => {
                        el.classList.remove(className)
                    });
                }
            }
        },
        handleScrollGroup: function (evt, el) {
            const isVisible = this.isVisible(el);
            const action = isVisible ? "add" : "remove";

            if (!isVisible && el.dataset.scrollOnce) {
                return;
            }

            const elements = Array.from(el.getElementsByClassName("js-scroll"));
            elements.forEach(element => {
                const classes = (element.dataset.scrollClass || "").trim().split(" ");
                classes.forEach(cssClass => element.classList[action](cssClass));
            });
        },
        isVisible(el) {
            const bounding = el.getBoundingClientRect()
            const bottomDistance = Number(el.dataset.scrollButtonDistance || 0);
            const isOnTheButton = bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + bottomDistance;
            const animationRate = el.dataset.scrollAnimationRate || 1.5;
            return Math.round(Math.abs(bounding.top)) <= Math.round((bounding.bottom / animationRate)) && isOnTheButton;
        }
    }
})